module.exports = __webpack_public_path__ + "static/cell-phone-repair-0cd787d42900cfd6b0e361f10ac94132.webp";